export enum ContractValidityType {
  /** Platnost smlouvy dle znění při podpisu. */
  Signed = "Signed",
  /** Platnost smlouvy včetně potenciálního pozdějšího zkrácení. */
  Final = "Final",
}
